
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Modal, Box, IconButton } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import apiCumbres from "../axios/axios";
import { useEffect, useState } from "react";
import LoadingSpinner from '../Spinner';
import { Flip, ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "./toastify/config";
import { styleBtn, sxTableHead, textFieldStyle } from "./Styles";
import Swal from "sweetalert2";



const ModalInfoPrestamoClientes = ({ open, onClose, idpg }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [infoClientes, setInfoClientes] = useState([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);


    const buscarInfoClientes = () => {

        const buscar = async () => {
            console.log(idpg)
            try {
                setIsLoading(true)
                const infoClientes = await apiCumbres.get(`/revisar-prestamos/info-clientes-grupal/${idpg}`)

                setInfoClientes(infoClientes.data)

                setIsLoading(false)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    console.log(error.response)
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener pagos de préstamo, favor de volver a recargar!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                onClose()
                toast.error(msg_error, toast_config)
            }

        }

        buscar()

    }


    useEffect(() => {
        if (open) buscarInfoClientes()

        if (!open) {
            setPage(0)
            setRowsPerPage(5)
            setInfoClientes([])
        }

    }, [open])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    //VER COMO PASAR EL ID, YA QUE LLEGA UNDEFINED

    const formatNumber = (value) => {
        const [intPart, decimalPart] = value.split('.');

        const formattedInt = parseInt(intPart, 10).toLocaleString('en-US');
        return decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
    };



    return (
        <>
            <AnimatePresence>

                {open && (
                    <Modal
                        open={open}
                        onClose={onClose}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        <>
                            {isLoading ?
                                <LoadingSpinner />
                                : null}
                            {/* BACKDROP ANIMADO */}
                            <motion.div
                                key="backdrop"
                                initial={{ opacity: 0, backdropFilter: "blur(0px)" }}
                                animate={{ opacity: 1, backdropFilter: "blur(4px)" }}
                                exit={{ opacity: 0, backdropFilter: "blur(0px)" }}
                                transition={{ duration: 0.3 }}
                                style={{
                                    position: "fixed",
                                    inset: 0,
                                    background: "rgba(0,0,0,0.45)",
                                    zIndex: -1
                                }}
                                onClick={onClose}
                            />

                            <motion.div
                                initial={{ opacity: 0, scale: 0.6, rotate: -3 }}
                                animate={{ opacity: 1, scale: 1, rotate: 0 }}
                                exit={{ opacity: 0, scale: 0.8, rotate: 2 }}
                                transition={{
                                    duration: 0.35,
                                    ease: [0.25, 0.8, 0.25, 1]
                                }}
                                style={{ outline: "none" }}
                            >
                                <Box
                                    sx={{
                                        width: "min(1200px, 95vw)",
                                        maxHeight: "90vh",     // 🔑 permite crecer o encogerse
                                        minHeight: "300px",
                                        bgcolor: "background.paper",
                                        borderRadius: "12px",
                                        boxShadow: 24,
                                        position: "relative",
                                        mx: "auto",
                                        display: "flex",
                                        flexDirection: "column",
                                        overflow: "hidden",
                                    }}
                                >
                                    {/* TACHITA */}
                                    <IconButton
                                        onClick={onClose}
                                        sx={{ position: "absolute", top: 8, right: 8 }}
                                    >
                                        <HighlightOffIcon className="text-danger" />
                                    </IconButton>

                                    <Box sx={{ p: 3, flexShrink: 0 }}>
                                        <motion.h1 className="color-primary"
                                            initial={{ opacity: 0, y: -90 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, y: -20 }}
                                            transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 }}>
                                            Información Clientes
                                        </motion.h1>
                                        <hr className="mb-5" />
                                    </Box>

                                    <Box
                                        sx={{
                                            flex: 1,
                                            overflowY: "auto",   // 🔥 aquí vive el scroll vertical
                                            overflowX: "hidden",
                                            minWidth: 0,
                                            px: 3,
                                            pb: 2,
                                        }}
                                    >

                                        <TableContainer component={Paper} sx={{
                                            width: "100%",
                                            overflowX: "auto",   // 🔥 horizontal
                                            overflowY: "visible",
                                        }}>
                                            <Table >
                                                <TableHead>
                                                    <TableRow sx={{ backgroundColor: "#0a2540" }}>
                                                        <TableCell sx={sxTableHead}>#</TableCell>
                                                        <TableCell sx={sxTableHead}>Cliente</TableCell>
                                                        <TableCell sx={sxTableHead}>Monto</TableCell>
                                                        <TableCell sx={sxTableHead}>Interes</TableCell>
                                                        <TableCell sx={sxTableHead}>Pagado</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    <AnimatePresence component={null}>
                                                        {infoClientes
                                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((ic, index) => (
                                                                <motion.tr
                                                                    key={index}
                                                                    initial={{ opacity: 0, x: -50 }}
                                                                    animate={{ opacity: 1, x: 0 }}
                                                                    exit={{ opacity: 0, y: -40 }}
                                                                    transition={{
                                                                        duration: 0.4,
                                                                        ease: "easeOut",
                                                                        delay: 0.1 * index
                                                                    }}
                                                                    style={{
                                                                        backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff"
                                                                    }}
                                                                >
                                                                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                                                    <TableCell>{ic.nombrecliente}</TableCell>
                                                                    <TableCell>${formatNumber(ic.cantidadPrestar)}</TableCell>
                                                                    <TableCell>{ic.interes}%</TableCell>
                                                                    <TableCell>${ic.pagado ? formatNumber(ic.pagado) : '0.00'}</TableCell>

                                                                </motion.tr>
                                                            ))}
                                                    </AnimatePresence>
                                                </TableBody>
                                            </Table>
                                            <Box sx={{ flexShrink: 0 }}>
                                                <TablePagination
                                                    component="div"
                                                    count={infoClientes.length}
                                                    page={page}
                                                    onPageChange={handleChangePage}
                                                    rowsPerPage={rowsPerPage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    labelRowsPerPage="Registros por página"
                                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                                />
                                            </Box>

                                        </TableContainer>
                                    </Box>



                                </Box>
                            </motion.div>
                        </>
                    </Modal>
                )}

            </AnimatePresence >

            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />
        </>

    )

}

export default ModalInfoPrestamoClientes

